const importAll = (r) =>
  r.keys().reduce((acc, item) => {
    const key = item.replace("./", "");
    acc[key] = r(item);
    return acc;
  }, {});

const showcaseImages = importAll(
  require.context("../images/showcase_images", false, /\.(png|jpe?g|webp)$/)
);

const videos = importAll(
  require.context("../images/videos", false, /\.(mp4|webm|ogg)$/)
);

export const ProjectsInfo = [
  // AI Projects
  {
    ProjectName: "Intelligent SEC Filing Tracker and M&A Deal Analyzer",
    ProjectDescription:
      "An AI-driven platform that automatically fetches and analyzes SEC 8-K filings to identify merger and acquisition (M&A) deals containing Exhibit 2.1 (Agreement and Plan of Merger). Users can “follow” relevant deals, triggering a Django REST API pipeline that parses the SEC document, extracts structured legal data, performs intelligent chunking, and indexes the results into Pinecone for Retrieval-Augmented Generation (RAG). The system then leverages schema-based question answering and a summary engine to produce comprehensive clause-level summaries of merger agreements. Users can also add deals manually by URL or by deal details and generate AI-based summaries interactively.",
    TechUsed: [
      "Advanced RAG Pipeline (chunking + contextual retrieval)",
      "Pinecone (Vector Database)",
      "OpenAI GPT Models (for schema QA & summarization)",
      "Django REST Framework (backend)",
      "React + TypeScript + Tailwind (Vite frontend)",
      "MongoDB  (persistent storage)"
    ],
    Images: [
      showcaseImages["rag-deal-1.webp"],
      showcaseImages["rag-deal-2.webp"],
      showcaseImages["rag-deal-3.webp"],
      showcaseImages["rag-deal-4.webp"],
      showcaseImages["rag-deal-5.webp"],
      showcaseImages["rag-deal-6.webp"]
    ],
    Video: [],
    Category: "ai"
  },
  {
    ProjectName: "Docket Email Intelligence Workflow (n8n + Flask + LLM)",
    ProjectDescription:
      "Automated workflow built in n8n that listens to subscribed docket emails, extracts the docket number and source link from the message body, and routes it through a custom Flask scraping API that bypasses anti-bot measures to retrieve the full case/docket content. The parsed data is then sent to an LLM to generate a structured, human-readable summary. Finally, the workflow assembles an HTML email and delivers the summary to the predefined recipient list, enabling near real-time monitoring of new docket activity without manual review.",
    TechUsed: [
      "n8n",
      "IMAP email trigger",
      "Custom Flask scraping API",
      "Anti-bot handling",
      "OpenAI/LLM summarization",
      "HTML email generation",
      "Gmail/SMTP delivery"
    ],
    Images: [showcaseImages["docket-email-intelligence-1.webp"]],
    Video: [],
    Category: "ai"
  },
  {
    ProjectName: "AI Chatbot",
    ProjectDescription:
      "Develop a scalable, user-friendly AI chatbot integrated within a React web application, designed to support multiple tenants (clients/organizations), each with an independent and easily updatable knowledge base. The knowledge base will consist of text and PDF files specific to each tenant, allowing tailored conversational AI experiences. The platform should support simple onboarding of new tenants, straightforward knowledge base management, and seamless integration with OpenAI or similar models, prioritizing cost-effectiveness and ease of maintenance.",
    TechUsed: ["React", "Tailwind CSS", "Express.js", "OpenAI"],
    Images: [
      showcaseImages["ai-chatbot-1.webp"],
      showcaseImages["ai-chatbot-2.webp"],
      showcaseImages["ai-chatbot-3.webp"],
      showcaseImages["ai-chatbot-4.webp"],
      showcaseImages["ai-chatbot-5.webp"],
      showcaseImages["ai-chatbot-6.webp"],
      showcaseImages["ai-chatbot-7.webp"],
      showcaseImages["ai-chatbot-8.webp"],
      showcaseImages["ai-chatbot-9.webp"],
      showcaseImages["ai-chatbot-10.webp"]
    ],
    Video: [],
    Category: "ai"
  },
  {
    ProjectName: "CV Reviewer",
    ProjectDescription:
      "The AI-Powered CV Reviewer Platform is a modern web application designed to automate the analysis and review of CVs/résumés using advanced AI capabilities. The solution consists of a Node.js/Express backend service and a React/TypeScript frontend application. The backend ingests uploaded CVs in PDF format, extracts relevant data, and utilizes OpenAI’s GPT models to provide detailed, intelligent feedback, personal information extraction, and document classification. It incorporates robust error handling, duplicate detection, usage rate limiting, and persistent data storage in MongoDB. The frontend offers a responsive, user-friendly interface for uploading CVs, previewing PDF documents, and displaying AI-generated feedback in real time. Built with React, TypeScript, Vite, and Tailwind CSS, it ensures a seamless experience across devices. The entire system is engineered for scalability, security, and ease of deployment, empowering users to receive comprehensive, AI-driven CV reviews efficiently and reliably.",
    TechUsed: [
      "OpenAI API Integration",
      "Node.js",
      "MongoDB",
      "React",
      "Vite",
      "Tailwind CSS",
      "Git"
    ],
    Images: [
      showcaseImages["cv-reviewer-1.webp"],
      showcaseImages["cv-reviewer-2.webp"]
    ],
    Video: [videos["cv-reviewer-demo.mp4"]],
    Category: "ai"
  },

  // Web Apps
  {
    ProjectName: "Field Visit App",
    ProjectDescription:
      "An app to gather detailed information while the expert is at the customer's location regarding the property and project.The app was crafted seamlessly with pixel perfect design, flow less integration between frontend (React) and backend (node) with complex business logic handling along with fine tune/detail final report generation, as a pdf.",
    TechUsed: [
      "React",
      "Node Js",
      "Antd",
      "PDF Shift",
      "react-dnd",
      "Framer motion",
      "Redux"
    ],
    Images: [
      showcaseImages["field-visit-1.webp"],
      showcaseImages["field-visit-2.webp"],
      showcaseImages["field-visit-3.webp"],
      showcaseImages["field-visit-4.webp"],
      showcaseImages["field-visit-5.webp"]
    ],
    Video: [videos["field-visit-demo.mp4"]],
    Category: "web"
  },
  {
    ProjectName: "Proposal Builder",
    ProjectDescription:
      "Proposal builder is basically an app that facilitates user to generate/edit, run time proposal by dragging and dropping the products on floor plan while with customer. It has a very deep level of business logic and complex use case handling, nicely presented proposal template & seamlessly integrated with zoho.",
    TechUsed: [
      "Threejs",
      "React three fiber",
      "React",
      "Node.js",
      "react-dnd",
      "antd",
      "Framer motion",
      "Zustand"
    ],
    Images: [
      showcaseImages["proposal-1.webp"],
      showcaseImages["proposal-2.webp"],
      showcaseImages["proposal-3.webp"],
      showcaseImages["proposal-4.webp"],
      showcaseImages["proposal-5.webp"]
    ],
    Video: [],
    Category: "web"
  },
  {
    ProjectName: "Floorplan Drawer",
    ProjectDescription:
      "This app was add-on to the data collection (Field Visit) app which enables user to draw a floor plan with the considering all the complex floor plan drawing concept e.g. merge & rotate the rooms, add staircase & doors, calculating square ft. & linear ft. as per drawing dimensions along with facility to drag & drop products to the specific room on floor plan and generate rough estimate on the spot.",
    TechUsed: ["React", "Node Js", "Canvas", "Redux", "Antd"],
    Images: [
      showcaseImages["floor-plan-1.webp"],
      showcaseImages["floor-plan-2.webp"],
      showcaseImages["floor-plan-3.webp"],
      showcaseImages["floor-plan-4.webp"],
      showcaseImages["floor-plan-5.webp"],
      showcaseImages["floor-plan-6.webp"],
      showcaseImages["floor-plan-7.webp"]
    ],
    Video: [],
    Category: "web"
  },
  {
    ProjectName: "Product Gallery",
    ProjectDescription:
      "This immersive 3D Wooden Product Gallery offers users a captivating walkthrough experience built with React and Three.js. The gallery features a cylindrical wall adorned with picture frames arranged in two rows, showcasing products dynamically. At the center of the room is an interactive table with a virtual book that serves as the core navigation element. Users can select a product type from the book's front page, triggering a page-turn animation that applies dynamic filters to the displayed products, updating the gallery in real time. Subsequent page turns allow users to refine their selections or explore additional filters, with seamless transitions and visual updates. This project combines interactivity, aesthetics, and functionality to create an engaging and intuitive way for users to explore products in a virtual space.",
    TechUsed: [
      "React",
      "Threejs",
      "React three fiber",
      "Tailwind CSS",
      "Redux",
      "Context"
    ],
    Images: [
      showcaseImages["product-gallery-1.webp"],
      showcaseImages["product-gallery-2.webp"],
      showcaseImages["product-gallery-3.webp"],
      showcaseImages["product-gallery-4.webp"],
      showcaseImages["product-gallery-5.webp"]
    ],
    Video: [videos["product-gallery-demo.mp4"]],
    Category: "web"
  },
  {
    ProjectName: "Project Backlogs",
    ProjectDescription:
      "This Project Management Scheduling Tool is a highly interactive and intuitive platform designed to streamline project scheduling and team assignments. The app features a dedicated backlog section for projects without estimated start dates, allowing users to drag and drop these into fiscal week columns for effective planning. Clicking on a fiscal week opens a detailed week view, enabling day-by-day team-specific project assignments. Projects can be cloned to accommodate multi-team collaboration, with safeguards to prevent duplicate assignments on the same day.  custom fiscal week and daily scheduling views, and ensures teams can efficiently manage resources and meet deadlines.",
    TechUsed: ["React", "Node.js", "Mui", "react-dnd"],
    Images: [
      showcaseImages["project-management-1.webp"],
      showcaseImages["project-management-2.webp"],
      showcaseImages["project-management-3.webp"],
      showcaseImages["project-management-4.webp"],
      showcaseImages["project-management-5.webp"]
    ],
    Video: [videos["project-management-demo.mp4"]],
    Category: "web"
  },
  {
    ProjectName: "3D walkthrough",
    ProjectDescription:
      "The project involves creating an interactive 3D visualization using Three.js and SVG. It starts by importing AutoCAD plans and associated data to generate an SVG-based floor plan. The SVG includes resizable bounding boxes and interactive hotspots that users can click. When a hotspot is clicked, a 360-degree image is loaded into a spherical environment in Three.js, allowing users to navigate the interior of a home and explore different positions interactively. Additionally, users can switch between floors seamlessly, providing a comprehensive virtual tour experience of the entire home.",
    TechUsed: [
      "React",
      "Node.js",
      "use-gesture",
      "antd",
      "jszip",
      "threejs",
      "zustand"
    ],
    Images: [
      showcaseImages["walkthrough-1.webp"],
      showcaseImages["walkthrough-2.webp"],
      showcaseImages["walkthrough-3.webp"],
      showcaseImages["walkthrough-4.webp"],
      showcaseImages["walkthrough-5.webp"]
    ],
    Video: [],
    Category: "web"
  },
  // UI/UX Designs
  {
    ProjectName: "Prayosha Construction",
    ProjectDescription:
      "This project is a modern Vite + React + TypeScript web application developed for Prayosha Construction. It features a fast, modular architecture powered by Vite, scalable UI components built with React, and type-safe logic using TypeScript. The project includes smooth animations with GSAP, 3D interactive elements using Three.js and React Three Fiber, and a clean, responsive interface styled with Tailwind CSS. The build is optimized for performance, maintainability, and future expansion, making it suitable for a high-quality construction or real-estate focused website.",
    TechUsed: [
      "React.js",
      "TypeScript",
      "Vite",
      "Tailwind CSS",
      "Three.js",
      "GSAP",
      "Supabase"
    ],
    Images: [
      showcaseImages["prayosha-construction-1.webp"],
      showcaseImages["prayosha-construction-2.webp"],
      showcaseImages["prayosha-construction-3.webp"],
      showcaseImages["prayosha-construction-4.webp"],
      showcaseImages["prayosha-construction-5.webp"],
      showcaseImages["prayosha-construction-6.webp"],
      showcaseImages["prayosha-construction-7.webp"],
      showcaseImages["prayosha-construction-8.webp"],
      showcaseImages["prayosha-construction-9.webp"],
      showcaseImages["prayosha-construction-10.webp"]
    ],
    Video: [videos["prayosha-construction-demo-1.mp4"]],
    Category: "ui_designs"
  },
  {
    ProjectName: "NeonBoard",
    ProjectDescription:
      "NeonBoard is a modern web application built using React, TypeScript, and Vite, designed for fast performance and a smooth development workflow. The project features a clean and responsive UI powered by Tailwind CSS, dynamic icons using Lucide React. The architecture is optimized for scalability, maintainability, and real-time interaction. With strong developer tooling such as TypeScript, ESLint, and PostCSS, NeonBoard delivers a stable, efficient, and visually polished user experience.",
    TechUsed: [
      "React.js",
      "TypeScript",
      "Vite",
      "Tailwind CSS",
      "Lucide React Icons"
    ],
    Images: [
      showcaseImages["neon-board-1.webp"],
      showcaseImages["neon-board-2.webp"],
      showcaseImages["neon-board-3.webp"],
      showcaseImages["neon-board-4.webp"],
      showcaseImages["neon-board-5.webp"],
      showcaseImages["neon-board-6.webp"]
    ],
    Video: [videos["neon-board-demo.mp4"]],
    Category: "ui_designs"
  },
  {
    ProjectName: "Medical and Healthcare Service Website",
    ProjectDescription:
      "The Medical and Healthcare Service Website is a modern, responsive, and visually engaging platform designed to connect patients with healthcare professionals seamlessly. This project focuses on clean UI/UX design, ensuring a smooth and trustworthy digital experience for users in the medical domain.",
    TechUsed: [
      "React.js + Vite",
      "TypeScript",
      "Tailwind CSS",
      "Radix UI",
      "Embla Carousel",
      "Sonner Toasts",
      "GSAP Animations"
    ],
    Images: [
      showcaseImages["medical-and-health-service-1.webp"],
      showcaseImages["medical-and-health-service-2.webp"],
      showcaseImages["medical-and-health-service-3.webp"],
      showcaseImages["medical-and-health-service-4.webp"],
      showcaseImages["medical-and-health-service-5.webp"],
      showcaseImages["medical-and-health-service-6.webp"],
      showcaseImages["medical-and-health-service-7.webp"]
    ],
    Video: [],
    Category: "ui_designs"
  },
  {
    ProjectName: "Cinematic Blogger",
    ProjectDescription:
      "A modern, responsive web application built with React, TypeScript, and Vite. The project uses Tailwind CSS and shadcn/ui for clean, accessible UI components. It includes form handling with React Hook Form + Zod, smooth animations using Framer Motion, and optimized data fetching with React Query. Routing is managed through React Router, while Three.js and React Three Fiber enable 3D elements. The architecture is clean, scalable, and designed for high-quality user experience.",
    TechUsed: [
      "React.js",
      "TypeScript",
      "Vite",
      "Tailwind CSS",
      "shadcn/ui",
      "Radix UI",
      "Framer Motion",
      "React Hook Form",
      "Zod",
      "React Query",
      "React Router",
      "Three.js"
    ],
    Images: [
      showcaseImages["cinematic-blogger-1.webp"],
      showcaseImages["cinematic-blogger-2.webp"],
      showcaseImages["cinematic-blogger-3.webp"],
      showcaseImages["cinematic-blogger-4.webp"],
      showcaseImages["cinematic-blogger-5.webp"],
      showcaseImages["cinematic-blogger-6.webp"],
      showcaseImages["cinematic-blogger-7.webp"],
      showcaseImages["cinematic-blogger-8.webp"],
      showcaseImages["cinematic-blogger-9.webp"],
      showcaseImages["cinematic-blogger-10.webp"]
    ],
    Video: [videos["cinematic-blogger-demo.mp4"]],
    Category: "ui_designs"
  },
  {
    ProjectName: "Neural AI",
    ProjectDescription:
      "Neural AI is a modern web-based platform designed to showcase AI-powered innovations and interactive 3D elements using a clean, minimal UI.",
    TechUsed: [
      "React.js + Vite",
      "TypeScript",
      "Tailwind CSS",
      "GSAP",
      "Lucide React Icons"
    ],
    Images: [
      showcaseImages["neural-ai-1.webp"],
      showcaseImages["neural-ai-2.webp"],
      showcaseImages["neural-ai-3.webp"],
      showcaseImages["neural-ai-4.webp"],
      showcaseImages["neural-ai-5.webp"],
      showcaseImages["neural-ai-6.webp"],
      showcaseImages["neural-ai-7.webp"],
      showcaseImages["neural-ai-8.webp"],
      showcaseImages["neural-ai-9.webp"],
      showcaseImages["neural-ai-10.webp"]
    ],
    Video: [videos["neural-ai-demo-1.mp4"], videos["neural-ai-demo-2.mp4"]],
    Category: "ui_designs"
  }
];

/*
  {
    ProjectName: "000",
    ProjectDescription:
      "000",
    TechUsed: [
      "000",
    ],
    Images: [
      showcaseImages["000.webp"],
    ],
    Video: [videos["000.mp4"]],
    Category: "000",
  },
*/
